import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CheckCircle2, Zap, Clock, Download, Star, BadgeCheck } from 'lucide-react';
export function CTASection() {
  const included = ['The "Shadow Clause" — exact legal addendum', '2025 ZIP Code Heatmap — 12 high-yield blocks', '"Furniture-to-Profit" Ratio calculator', '3-App Autopilot setup guide', '"Lean Start" chapter (under $7k capital)', 'Landlord negotiation scripts', 'Corporate tenant acquisition playbook'];
  return <section id="pricing" className="w-full bg-[#0a0f1a] py-16 md:py-32 px-4 border-t border-[#c9a84c]/20 relative overflow-hidden" data-id="element-23">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#c9a84c]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-24"></div>
      <div className="absolute top-0 left-1/4 w-[300px] h-[300px] bg-[#c9a84c]/3 rounded-full blur-[100px] pointer-events-none" data-id="element-25"></div>
      <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-[#c9a84c]/3 rounded-full blur-[100px] pointer-events-none" data-id="element-26"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-27">
        {/* Section Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-28">
          <p className="text-[#c9a84c] text-xs md:text-sm font-bold tracking-[0.15em] md:tracking-[0.2em] uppercase mb-3 md:mb-4" data-id="element-29">
            Limited-Time Offer
          </p>
          <h2 className="font-serif text-2xl md:text-5xl text-white leading-tight" data-id="element-30">
            Get the Complete Blueprint
            <br data-id="element-31" />
            <span className="text-[#c9a84c]" data-id="element-32">
              Before the Price Goes Back Up
            </span>
          </h2>
        </motion.div>

        {/* Main Offer Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-33">
          {/* Gold border glow */}
          <div className="absolute -inset-[1px] bg-gradient-to-b from-[#c9a84c] via-[#c9a84c]/30 to-[#c9a84c] rounded-2xl opacity-40" data-id="element-34"></div>

          <div className="relative bg-[#0f1724] rounded-2xl overflow-hidden" data-id="element-35">
            {/* Top Badge */}
            <div className="bg-gradient-to-r from-[#c9a84c] via-[#d4af37] to-[#c9a84c] py-3 text-center" data-id="element-36">
              <p className="text-[#0f1724] font-bold text-sm md:text-base uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-37">
                <Zap className="w-4 h-4" data-id="element-38" />
                86% OFF — Launch Promotion
                <Zap className="w-4 h-4" data-id="element-39" />
              </p>
            </div>

            <div className="p-5 md:p-12" data-id="element-40">
              {/* Product Image + Price Side by Side */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 items-center mb-8 md:mb-10" data-id="element-41">
                {/* Product Image */}
                <div className="flex justify-center" data-id="element-42">
                  <div className="relative" data-id="element-43">
                    <div className="absolute -inset-2 bg-gradient-to-r from-[#c9a84c]/20 to-[#d4af37]/20 rounded-lg blur-lg" data-id="element-44"></div>
                    <img src="https://cdn.magicpatterns.com/uploads/vD1fvQ2KC2usfYbP7kGwXB/heylloyd-image-1771358355863.png" alt="The Shadow Rental Method Blueprint" className="relative w-full max-w-[200px] md:max-w-[260px] rounded-lg shadow-2xl border border-[#c9a84c]/20" data-id="element-45" />
                  </div>
                </div>

                {/* Price Block */}
                <div className="text-center md:text-left space-y-4" data-id="element-46">
                  <p className="text-[#f5f0e8]/60 text-xs md:text-sm uppercase tracking-wider font-bold" data-id="element-47">
                    The Shadow Rental Method — 2025 Edition
                  </p>

                  {/* Price Ladder */}
                  <div className="space-y-1.5 md:space-y-2" data-id="element-48">
                    <div className="flex items-center gap-2 md:gap-3 justify-center md:justify-start" data-id="element-49">
                      <span className="text-[#f5f0e8]/40 text-xs md:text-sm w-28 md:w-auto" data-id="element-50">
                        Real estate courses:
                      </span>
                      <span className="text-[#ef4444]/60 line-through text-base md:text-lg" data-id="element-51">
                        $5,000
                      </span>
                    </div>
                    <div className="flex items-center gap-2 md:gap-3 justify-center md:justify-start" data-id="element-52">
                      <span className="text-[#f5f0e8]/40 text-xs md:text-sm w-28 md:w-auto" data-id="element-53">
                        Weekend seminars:
                      </span>
                      <span className="text-[#ef4444]/60 line-through text-base md:text-lg" data-id="element-54">
                        $2,000
                      </span>
                    </div>
                    <div className="flex items-center gap-2 md:gap-3 justify-center md:justify-start" data-id="element-55">
                      <span className="text-[#f5f0e8]/40 text-xs md:text-sm w-28 md:w-auto" data-id="element-56">
                        Regular price:
                      </span>
                      <span className="text-[#ef4444] line-through text-lg md:text-xl font-bold" data-id="element-57">
                        $47
                      </span>
                    </div>
                  </div>

                  {/* Current Price */}
                  <div className="pt-3 md:pt-4 border-t border-[#c9a84c]/20" data-id="element-58">
                    <p className="text-[#f5f0e8]/60 text-xs md:text-sm uppercase tracking-wider mb-1" data-id="element-59">
                      Today only:
                    </p>
                    <div className="flex items-end gap-1 md:gap-2 justify-center md:justify-start" data-id="element-60">
                      <span className="text-[#c9a84c] text-5xl md:text-7xl font-bold leading-none" data-id="element-61">
                        $6
                      </span>
                      <span className="text-[#c9a84c] text-2xl md:text-4xl font-bold leading-none mb-1" data-id="element-62">
                        .36
                      </span>
                    </div>
                    <div className="mt-3 inline-block bg-[#10b981]/10 border border-[#10b981]/30 rounded-full px-4 py-1.5" data-id="element-63">
                      <span className="text-[#10b981] font-bold text-sm" data-id="element-64">
                        💰 You save $40.64
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Gold Divider */}
              <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/40 to-transparent mb-6 md:mb-10" data-id="element-65"></div>

              {/* What's Included Recap */}
              <div className="mb-6 md:mb-10" data-id="element-66">
                <p className="text-[#c9a84c] font-bold text-base md:text-lg mb-4 md:mb-6 text-center uppercase tracking-wider" data-id="element-67">
                  Everything Included:
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-68">
                  {included.map((item, index) => <motion.div key={index} initial={{
                  opacity: 0,
                  x: -10
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.3,
                  delay: index * 0.05
                }} className="flex items-start gap-3" data-id="element-69">
                      <CheckCircle2 className="w-5 h-5 text-[#c9a84c] flex-shrink-0 mt-0.5" data-id="element-70" />
                      <span className="text-[#f5f0e8]/90 text-xs md:text-base" data-id="element-71">
                        {item}
                      </span>
                    </motion.div>)}
                </div>
              </div>

              {/* CTA Button */}
              <div className="text-center" data-id="element-72">
                <motion.a href="https://www.betterbysteps.com/cart/44210855575645:1" target="_blank" rel="noopener noreferrer" whileHover={{
                scale: 1.03
              }} whileTap={{
                scale: 0.98
              }} className="inline-block relative w-full md:w-auto px-6 md:px-10 py-4 md:py-5 bg-gradient-to-r from-[#c9a84c] via-[#d4af37] to-[#c9a84c] text-[#0f1724] text-lg md:text-2xl font-bold rounded-xl shadow-[0_0_30px_rgba(201,168,76,0.4)] hover:shadow-[0_0_50px_rgba(201,168,76,0.6)] transition-shadow duration-500 no-underline text-center" data-id="element-73">
                  DOWNLOAD NOW $6.36
                </motion.a>

                {/* Trust Row */}
                <div className="mt-6 md:mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-6 text-[#f5f0e8]/50 text-[10px] md:text-xs uppercase tracking-wider" data-id="element-74">
                  <div className="flex items-center gap-1.5" data-id="element-75">
                    <Lock className="w-3.5 h-3.5" data-id="element-76" />
                    <span data-id="element-77">Secure Checkout</span>
                  </div>
                  <div className="flex items-center gap-1.5" data-id="element-78">
                    <Zap className="w-3.5 h-3.5" data-id="element-79" />
                    <span data-id="element-80">Instant Delivery</span>
                  </div>
                  <div className="flex items-center gap-1.5" data-id="element-81">
                    <ShieldCheck className="w-3.5 h-3.5" data-id="element-82" />
                    <span data-id="element-83">30-Day Guarantee</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Guarantee Footer */}
            <div className="bg-[#111827] border-t border-[#c9a84c]/10 p-5 md:p-8" data-id="element-84">
              <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 max-w-2xl mx-auto" data-id="element-85">
                <div className="flex-shrink-0" data-id="element-86">
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-[#c9a84c] flex items-center justify-center bg-[#c9a84c]/5" data-id="element-87">
                    <BadgeCheck className="w-8 h-8 md:w-10 md:h-10 text-[#c9a84c]" data-id="element-88" />
                  </div>
                </div>
                <div className="text-center md:text-left" data-id="element-89">
                  <h4 className="font-serif text-lg md:text-xl text-[#c9a84c] font-bold mb-1 md:mb-2" data-id="element-90">
                    30-Day Money-Back Guarantee
                  </h4>
                  <p className="text-[#f5f0e8]/70 text-xs md:text-sm leading-relaxed" data-id="element-91">
                    If this blueprint doesn't change how you think about
                    retirement income, you get every penny back. No questions
                    asked. No hoops to jump through. Your investment is 100%
                    protected.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Bottom Urgency Note */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mt-8 text-center" data-id="element-92">
          <div className="inline-flex items-center gap-2 bg-[#ef4444]/10 border border-[#ef4444]/20 rounded-full px-4 md:px-5 py-2" data-id="element-93">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 text-[#ef4444]" data-id="element-94" />
            <span className="text-[#ef4444] text-xs md:text-sm font-bold" data-id="element-95">
              Price returns to $47 when this promotion ends
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}